import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { BoxModule } from '@greco/ui-box';
import { SimpleDialogModule } from '@greco/ui-dialog-simple';
import { TableModule } from '@greco/ui-table';
import { ActivityPage } from './pages';
import { MailPage } from './pages/mail/mail.page';
import { MailServiceModule } from './services';

@NgModule({
  imports: [
    CommonModule,
    TableModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatMenuModule,
    MatDialogModule,
    SimpleDialogModule,
    RouterModule,
    MailServiceModule,
    MatInputModule,
    MatFormFieldModule,
    MatSnackBarModule,
    BoxModule,
    ReactiveFormsModule,
  ],
  exports: [MailPage, ActivityPage],
  declarations: [MailPage, ActivityPage],
})
export class MailModule {}
